export const BLE_PERIPHERAL_CONNECTION_STATUS = Object.freeze({
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
});

export const BLE_PERIPHERAL_BATTERY_STATUS = Object.freeze({
  FULL: 'full',
  MID: 'mid',
  LOW: 'low',
  EMPTY: 'empty',
})

export type BLE_PERIPHERAL_CONNECTION_STATUS = typeof BLE_PERIPHERAL_CONNECTION_STATUS[
  keyof typeof BLE_PERIPHERAL_CONNECTION_STATUS
]

export type BLE_PERIPHERAL_BATTERY_STATUS = typeof BLE_PERIPHERAL_BATTERY_STATUS[
    keyof typeof BLE_PERIPHERAL_BATTERY_STATUS
]
